export enum MarketplaceSortingKey {
  Popularity = 'popularity',
  Distance = 'distance',
  Joined = 'joined',
  Review = 'review'
}
